export default __webpack_public_path__ + "static/media/List-documentation.9352ee6a.md";